import React, { FC, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Box, Tooltip } from '@material-ui/core';
import url from 'url';
import { Button, IconInfo, IconSync, TypographyWrapper } from '../../components';
import { TypographyWeight } from '../../components/TypographyWrapper/TypographyWrapper';
import { useAppDispatch } from '../../hooks/appDispatch';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import { Feature } from '../../util/featureFlags';
import { ButtonVariant } from '../../components/Button/Button';
import { getRemoteValueStore } from './EditListingPage.utils';
import { setUnsavedListingValues } from './EditListingPage.duck';
import css from './EditListingPage.module.css';
import { useIsMobile } from '../../hooks/useIsMobile';

const QRCode: FC = () => {
  const [isSyncing, setIsSyncing] = useState(false);

  const dispatch = useAppDispatch();
  const isMobile = useIsMobile();

  const isQRCodeEnabled = useFeatureFlags(Feature.QRCode);
  let QRCodeUrl = '';
  if (typeof window !== 'undefined') {
    const parsedUrl = url.parse(window.location.href);
    const search = parsedUrl.search ? `${parsedUrl.search}&from-qr=true` : '?from-qr=true';
    QRCodeUrl = url.format({ ...parsedUrl, search });
  }

  if (isMobile || !isQRCodeEnabled) return null;

  const handleClick = async () => {
    // Rehydrate state with values from remote store
    const { formValues: remoteValues } = await getRemoteValueStore();
    if (remoteValues) {
      setIsSyncing(true);
      const oneSecondDelayPromise = new Promise((resolve) => setTimeout(resolve, 1000));

      // This often completes so quickly it may seem instantaneous. To provide visual
      // feedback, we ensure the loading icon is displayed for at least one second.
      await Promise.all([oneSecondDelayPromise, dispatch(setUnsavedListingValues(remoteValues))]);

      setIsSyncing(false);
    }
  };

  return (
    <Box m={2}>
      <TypographyWrapper variant="body2" weight={TypographyWeight.Bold}>
        Upload From Your Phone
      </TypographyWrapper>
      <Box my={2}>
        <QRCodeSVG value={QRCodeUrl} />
        <Box display="flex" alignItems="center" mt={2}>
          <Button
            id="sync-mobile-updates"
            variant={ButtonVariant.Primary}
            className={css.qrSyncButton}
            inProgress={isSyncing}
            onClick={handleClick}
            style={{ padding: '4px' }}
          >
            <Box display="inline">
              <IconSync />
            </Box>
            Sync
          </Button>
          <Tooltip
            title="If you’ve made changes or added photos on mobile, 
                press the sync button to see those changes reflected here."
            placement="top-start"
          >
            <Box display="flex" alignItems="center">
              <IconInfo />
            </Box>
          </Tooltip>
        </Box>
      </Box>
    </Box>
  );
};

export default QRCode;
